import React, { useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet'

/**
 * Shared public shell for Zoom support and documentation resources.
 * Uses the same visual language as Experience Events / Prosperity pages.
 *
 * @param {object} props Resource page metadata and visible content.
 * @returns {React.ReactElement} A branded resource page.
 */
const ZoomResourceLayout = ({
  title,
  description,
  path,
  eyebrow,
  heading,
  intro,
  children,
}) => {
  // These routes sit outside authenticated Layout, which normally resets scroll.
  useLayoutEffect(() => {
    window.scrollTo(0, 0)
  }, [title])

  const pageTitle = `${title} | Abroad`
  const pageUrl = path ? `${process.env.REACT_APP_DOMAIN}${path}` : undefined

  return (
    <div className='bg-background prosperity-page zoom-resource-page'>
      <Helmet>
        <title>{pageTitle}</title>
        <meta property='og:title' content={pageTitle} />
        <meta property='twitter:title' content={pageTitle} />
        <meta name='description' content={description} />
        {pageUrl && <meta property='og:url' content={pageUrl} />}
        {pageUrl && <meta property='twitter:url' content={pageUrl} />}
        <meta name='robots' content='noindex' />
      </Helmet>

      <nav className='pt-3'>
        <div className='container px-3 d-flex justify-content-center justify-content-md-start'>
          <a href='https://www.abroad.io/' className='navbar-brand'>
            <img
              src='https://images.squarespace-cdn.com/content/v1/63db562b53fc5e6e59ef802c/98522d73-daa5-49ab-bc3c-0468ca75ee95/Group+1989.png'
              alt='Abroad Logo'
              style={{ height: '59px', width: '98px' }}
            />
          </a>
        </div>
      </nav>

      <main className='content-fade-in'>
        <div className='container px-3 py-5'>
          <div className='zoom-resource-intro text-center mx-auto mb-5'>
            {eyebrow && (
              <p className='text-gold-light text-uppercase font-montserrat small-title-2 fw-bold tracking-widest mb-3'>
                {eyebrow}
              </p>
            )}
            <h1 className='font-heading zoom-resource-title text-rich-navy mb-4'>
              {heading}
            </h1>
            <p className='font-paragraph zoom-resource-description text-rich-navy mb-0 mx-auto'>
              {intro}
            </p>
          </div>
          {children}
        </div>
      </main>
    </div>
  )
}

export default ZoomResourceLayout
